<template>
  <transition name="modal-body">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-800">
          <div class="modal-header">
            <slot name="header"> New Plant Variety </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-2">
                  <label for="plant_variety"> Plant Variety: </label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="new_plant_variety"
                    ref="plant_variety"
                    placeholder=" Enter plant variety common name"
                    v-modal="plant_variety"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-2">
                  <label for="plant_variety"> Botanical Name: </label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="New_plant_botany"
                    ref="plant_botany"
                    placeholder="enter botanical name"
                    v-modal="plant_botany"
                  />
                </div>
              </div>

            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
          
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CreatePlantVariety",

  // DATA
  data: () => ({
    plant_variety: "",
    plant_botany: "",
  }),

  // METHODS
  methods: {
    ...mapActions("inventory", ["apiCreatePlantBotany"]), // inventory.js

    _save() {
      if (!this.$refs.plant_variety.value) {
        alert("please enter a plant variety"); // todo - place the correct references
        return;
      }

      // TODO - Create a variable for the data
      var item = {
        id: 0,
        active: true,
        plant_variety: this.$refs.plant_variety.value,
        plant_botany: this.$refs.plant_botany.value,
      };

      this.apiCreatePlantBotany(item);
      this.$emit("close");
    },

    // TODO -
    getPlantVariety() {
      if (this.inventory == null) {
        return "";
      } else {
        return this.personnel_plant_variety;
      }
    },

    clear() {
      this.plant_variety = "";
      this.plant_botany = "";
      this.nursery_size = "";
    },
  },

  // COMPONENTS
  components: {},
};
</script>
